import { GET_SERVER_VERSION_SUCCESS, GET_SERVER_VERSION_ERROR } from "../actions/serverVersion";

export function serverVersion(state = [], action) {
    switch (action.type) {
        case GET_SERVER_VERSION_SUCCESS:
            return action.version;

        case GET_SERVER_VERSION_ERROR:
            return null;    
    
        default:
            return state;
    }
}